import React, { useState } from "react";
import "./Education-Policies.css";

import Footer from "../components/Footer";
import Navbar from "../components/navbar";
import CTAButtons from "../components/sticky-button";
import PageHeader from "./PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";
import BrochureForm from "../components/EnquiryForm";

const EducationalPolicy = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <div className="eo-page">
        <PageHeader
          title="Educational Organization Policy"
          crumbs={[
            { label: "Home", href: "/" }, 
            { label: "Educational Organization Policy" }
          ]}
        />
        
        <main className="eo-container eo-main">
          <div className="eo-section">
            
            {/* Core Policy Statement Paragraph */}
            <p className="eo-text">
              We, at Thakur Institute of Management Studies, Career Development
              &amp; Research are committed to offer excellence in software
              education, in inclusive and conducive academic environment for
              holistic development of our students. We work as a team and
              interact with students in pro-active manner to achieve our
              Educational Organization Objectives and fulfill all academic,
              statutory and regulatory requirements. We strive for continual
              improvement of our Educational Organizations Management System.
            </p>

            {/* Separator Wrapper Container */}
            <div className="eo-card-spacing-wrapper">
              
              <div className="eo-card">
                <div className="eo-card-image">
                  <img
                    src="/images/About/about.png"
                    alt="TIMSCDR campus building"
                  />
                </div>

                <div className="eo-card-content">
                  <div className="eo-card-header">
                    <span className="eo-card-icon" aria-hidden="true">
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="1.8" />
                        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="1.8" />
                        <path d="M16.5 7.5L11 13" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M17.5 6.5L20 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M20 4L16 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      </svg>
                    </span>

                    <div className="eo-card-title-wrapper">
                      <h3 className="eo-card-title">Strategic Objectives</h3>
                      <span className="eo-card-title-underline" />
                    </div>
                  </div>

                  {/* Replaced .eo-card-list with inline styles to override the numbered grid and match the bulleted image layout */}
                  <ul style={{ 
                    listStyleType: 'disc', 
                    paddingLeft: '24px', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    gap: '16px', 
                    color: '#263247', 
                    fontSize: '15px', 
                    lineHeight: '1.6',
                    margin: 0
                  }}>
                    <li>
                      <strong>Enhance academic excellence and learner success</strong><br />
                      Strengthen outcome-based teaching–learning, assessment practices, curriculum relevance, CO/PO attainment processes, mentoring, academic support and learner progression.[cite: 6]
                    </li>
                    <li>
                      <strong>Promote research, innovation and entrepreneurial thinking</strong><br />
                      Encourage research aptitude, problem-solving, innovation, project-based learning, publications, participation in technical events and idea development among students and faculty.[cite: 6]
                    </li>
                    <li>
                      <strong>Improve employability and career readiness</strong><br />
                      Strengthen industry-aligned learning, internships, certifications, live projects, aptitude/technical training, communication skills and structured placement readiness initiatives.[cite: 6]
                    </li>
                    <li>
                      <strong>Strengthen collaborations with stakeholders</strong><br />
                      Build meaningful engagement with industry, alumni, academia and research organizations through guest sessions, mentoring, curriculum inputs, projects, internships and institutional development activities.[cite: 6]
                    </li>
                    <li>
                      <strong>Promote ethical, socially responsible and sustainable practices</strong><br />
                      Integrate professional ethics, responsible technology use, inclusivity, community engagement, sustainability awareness and social responsibility into academic and institutional activities.[cite: 6]
                    </li>
                    <li>
                      <strong>Strengthen quality assurance and continuous improvement</strong><br />
                      Improve institutional processes through IQAC-linked reviews, feedback analysis, documentation, outcome attainment, internal audits and evidence-based decision-making.[cite: 6]
                    </li>
                  </ul>
                </div>
              </div>

            </div>
            
          </div>
        </main>
      </div>
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </>
  );
};

export default EducationalPolicy;